import {
  SET_FIXED_LINE_HOT_OFFERS,
  FAILED_SET_FIXED_LINE__HOT_OFFERS,
  SET_ALL_OFFERS,
} from './actionsTypes'

const initialState = {
  homeOffers: null,
  fixedLineAllOffers: null,
}

const fixedLineHotOffers = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_FIXED_LINE_HOT_OFFERS:
      return {
        ...state,
        homeOffers: payload,
      }
    case FAILED_SET_FIXED_LINE__HOT_OFFERS:
      return {
        ...state,
        errorMsg: payload,
      }
    case SET_ALL_OFFERS:
      return {
        ...state,
        fixedLineAllOffers: payload,
      }

    default:
      return state
  }
}

export default fixedLineHotOffers
